// @flow

/**
 * Module dependencies.
 */

import bowser from 'bowser';

/**
 * Export `isMobile`.
 */

export function isMobile() {
  return Boolean(bowser.mobile) || Boolean(bowser.tablet);
}

/**
 * Export `isTablet`.
 */

export function isTablet() {
  return Boolean(bowser.tablet);
}

/**
 * Export `isPhone`.
 */

export function isPhone() {
  return Boolean(bowser.mobile);
}



// WEBPACK FOOTER //
// ../src/client/core/utils/browser.js